import { TransformationType, Type } from "class-transformer";
import ApiCounterpartyBase from "@rmp/core/api/types/counterparty/apiCounterpartyBase";
import "reflect-metadata";
import { Transform } from "class-transformer";
import { isNumber } from "lodash";
import { CounterpartyTypeEnum } from "@rmp/core/types/CounterpartyTypeEnum";
import { ApiLegalEntityHead } from "@rmp/api-gateway";

export default class ApiLegalEntityCounterparty extends ApiCounterpartyBase {
	inn: string;
	ogrn: string;
	kpp: string;
	opf: string;
	longName: string;
	shortName: string;
	phone: string;
	email: string;
	legalAddress: string;
	@Transform(({ value }) => {
		return isNumber(value) ? new Date(value).toISOString() : value;
	})
	registrationDate: string;
	heads: ApiLegalEntityHead[];
	description: string;
	
	constructor(
		type: CounterpartyTypeEnum = CounterpartyTypeEnum.LEGAL_ENTITY,
		inn: string = "",
		ogrn: string = "",
		kpp: string = "",
		opf: string = "",
		longName: string = "",
		shortName: string = "",
		legalAddress: string = "",
		registrationDate: string = "",
		phone: string = "",
		email: string = "",
		heads: ApiLegalEntityHead[] = [],
		description: string = "",
	)
	{
		super(type);
		
		this.inn = inn;
		this.ogrn = ogrn;
		this.kpp = kpp;
		this.opf = opf;
		this.longName = longName;
		this.shortName = shortName;
		this.legalAddress = legalAddress;
		this.registrationDate = registrationDate;
		this.heads = heads;
		this.description = description;
		this.phone = phone;
		this.email = email;
	}
}
